<template>
  <div v-if="showModal" v-on="$listeners" id="window-modal" class="window-modal" role="dialog">
    <div id="window-modal-wrapper" class="window-modal__wrapper" tabindex="0">
      <!-- modal content -->
      <slot />
    </div>
  </div>
</template>

<script>
const html = document.querySelector('html')

export default {
  name: 'WindowModal',
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showModal() {
      this.hideScroll(this.openModal)
      return this.openModal
    },
  },

  methods: {
    hideScroll(isOpen) {
      if (isOpen) {
        html.classList.add('hideY')
      } else {
        html.classList.remove('hideY')
      }
    },

    preventScroll(e) {
      // when space bar is used
      e.keyCode == 32 && e.target === this.$el.firstElementChild && e.preventDefault()
    },
  },

  created() {
    window.addEventListener('keypress', this.preventScroll)
  },

  beforeDestroy() {
    window.removeEventListener('keypress', this.preventScroll)
    this.hideScroll(false)
  },
}
</script>

<style scoped>
.window-modal {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  background: var(--rgba-modal);
  animation-name: animate-modal;
  animation-duration: 0.6s;
  z-index: 201;
}

.window-modal__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  width: 100%;
  max-width: 768px;
  margin: 30px 20px 40px;
  outline: none;
  z-index: 202;
}

.window-modal__wrapper.large {
  max-width: 920px;
}

@keyframes animate-modal {
  0% {
    transform: translateY(40%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
